import React, { useEffect, useState } from "react";
import "./pricing.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../home-page/home-comps/Header";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import IosShareIcon from "@mui/icons-material/IosShare";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import AddLocationAltOutlinedIcon from "@mui/icons-material/AddLocationAltOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import StreamOutlinedIcon from "@mui/icons-material/StreamOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import { featuresArray } from "./pricing-feature-icons";

import Footer from "../home-page/home-comps/Footer";
import IsLoading from "../../../IsLoading";

let companyPlans, companyFeatures, companyPermissions, companyRoles;

export default function PricingPage() {
  const [loading, setLoading] = useState(false);
  const redirect = useNavigate();
  const [billingCycle, setBillingCycle] = useState("monthly");
  const plans = [
    {
      name: "Standard",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      priceYearly: 46386.0,
      priceMonthly: 3865.5,
      actualPrice: 12650,
      currency: "NGN",
      discount: "20% Off for yearly",
      class: "standard",
      actionBtn: "Get Started",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 qrcode label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "100 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "3 user",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
        {
          discription: "3 location +",
          logo: <AddLocationAltOutlinedIcon fontSize="large" />,
        },
      ],
      footer: "",
    },
    {
      name: "Professional",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      priceYearly: 71411.28,
      priceMonthly: 5950.94,
      actualPrice: 18500.0,
      currency: "NGN",
      discount: "20% Off for yearly",
      class: "professional",
      tag: "Most Popular",
      actionBtn: "Start Professionally",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 qrcode label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "500 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "6 users",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
        {
          discription: "2 location +",
          logo: <AddLocationAltOutlinedIcon fontSize="large" />,
        },
      ],
      footer:
        "Ideal for growing businesses that require advanced inventory management, multi-user access, and enhanced reporting features to streamline operations and support expansion.",
    },
    {
      name: "Premium",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      priceYearly: 198000.0,
      priceMonthly: 16500.0,
      actualPrice: 49500.0,
      currency: "NGN",
      discount: "20% Off for yearly",
      class: "premium",
      actionBtn: "Go Premium",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "+ Unlimited QR Code label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "2,000 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "12 users",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
      ],
      footer:
        "Built for established businesses that require powerful inventory control, team collaboration, detailed reporting, and scalable operations for higher sales volume.",
    },
    {
      name: "Enterprise",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      price: "",
      priceYearly: 310200.0,
      priceMonthly: 25850.0,
      actualPrice: 77550.0,
      currency: "NGN",
      discount: "20% Off for yearly",
      class: "enterprise",
      tag: "Advance",
      actionBtn: "Unlock Full Access",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "+ Unlimited Barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "+ Unlimited QR Code label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "15,000+ unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "45 users +",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
        {
          discription: "4 location +",
          logo: <AddLocationAltOutlinedIcon fontSize="large" />,
        },
      ],
      footer:
        "Best for large businesses and multi-location companies that need enterprise-grade performance, massive inventory management, advanced reporting, and support for large teams.",
    },
  ];

  const comparisonRow = [
    {
      title: "Unique Items",
      values: ["100", "500", "2,000", "15,000"],
    },
    {
      title: "User Licenses",
      values: ["1", "2", "5", "8"],
    },
    {
      title: "Inventory Import",
      values: ["✓", "✓", "✓"],
    },
    {
      title: "QR Code Labels",
      values: ["", "✓", "✓"],
    },
    {
      title: "Purchase Orders",
      values: ["", "", "✓"],
    },
    {
      title: "API Access",
      values: ["", "", "", ""],
    },
  ];

  const comparisonSections = [
    {
      heading: "Business Capacity",
      rows: [
        {
          title: "Unique Products",
          values: ["100", "500", "2,000", "15,000"],
        },
        {
          title: "Users",
          values: ["3", "6", "12", "45"],
        },
        {
          title: "Business Locations",
          values: ["1", "2", "10", "Unlimited"],
        },
        {
          title: "Warehouses",
          values: ["1", "2", "10", "Unlimited"],
        },
        {
          title: "POS Registers",
          values: ["1", "4", "12", "Unlimited"],
        },
        // {
        //   title: "Cloud Storage",
        //   values: ["1 GB", "5 GB", "20 GB", "100 GB+"],
        // },
      ],
    },

    {
      heading: "Sales & Inventory",
      rows: [
        {
          title: "Point of Sale (POS)",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Barcode Generation",
          values: ["40", "200", "500", "Unlimited"],
        },
        {
          title: "QR Code Generation",
          values: ["40", "200", "500", "Unlimited"],
        },
        {
          title: "Stock Adjustments",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Stock Transfers",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Purchase Management",
          values: ["✓", "✓", "✓", "✓"],
        },
      ],
    },

    {
      heading: "Customers & Suppliers",
      rows: [
        {
          title: "Customers",
          values: ["500", "5,000", "50,000", "Unlimited"],
        },
        {
          title: "Suppliers",
          values: ["50", "500", "5,000", "Unlimited"],
        },
        {
          title: "Customer Credit/Debit",
          values: ["", "✓", "✓", "✓"],
        },
        {
          title: "Supplier Management",
          values: ["", "✓", "✓", "✓"],
        },
      ],
    },

    {
      heading: "Business Management",
      rows: [
        {
          title: "Finance Module",
          values: ["", "", "✓", "✓"],
        },
        {
          title: "Staff Management",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Warehouse Management",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Multi-Branch Management",
          values: ["", "", "", "✓"],
        },
        {
          title: "Multi-Company Support",
          values: ["", "", "✓", "✓"],
        },
      ],
    },

    {
      heading: "Reports & Analytics",
      rows: [
        {
          title: "Sales Reports",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Inventory Reports",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Financial Reports",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Business Analytics",
          values: ["", "", "Basic", "Advanced"],
        },
        {
          title: "Audit Logs",
          values: ["", "", "", "✓"],
        },
      ],
    },

    {
      heading: "Security & Backup",
      rows: [
        {
          title: "Two-Factor Authentication",
          values: ["", "✓", "✓", "✓"],
        },
        {
          title: "Custom Roles & Permissions",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Automatic Backup",
          values: ["", "", "✓", "✓"],
        },
        {
          title: "Backup Retention",
          values: ["-", "7 Days", "30 Days", "365 Days"],
        },
        {
          title: "SSO & IP Restrictions",
          values: ["", "", "", "✓"],
        },
      ],
    },

    {
      heading: "Integrations & Support",
      rows: [
        {
          title: "QuickBooks Integration",
          values: ["", "", "✓", "✓"],
        },
        {
          title: "Third-Party Apps",
          values: ["", "", "✓", "✓"],
        },
        {
          title: "Developer API",
          values: ["", "", "", "100K Requests/Day"],
        },
        {
          title: "Webhooks",
          values: ["", "", "", "✓"],
        },
        {
          title: "Email Support",
          values: ["✓", "✓", "✓", "✓"],
        },
        {
          title: "Live Chat",
          values: ["", "✓", "✓", "✓"],
        },
        {
          title: "Phone Support",
          values: ["", "✓", "✓", "✓"],
        },
        {
          title: "Priority Support",
          values: ["", "", "✓", "✓"],
        },
        {
          title: "Dedicated Account Manager",
          values: ["", "", "", "✓"],
        },
      ],
    },
  ];

  const apiGetCompanyData = async (signal) => {
    setLoading(true);

    try {
      const axiosConfig = {
        timeout: 30000,
        signal,
        headers: {
          "Content-Type": "application/json",
        },
      };

      const [plansResponse, featuresResponse] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/company_features/get_plans`,
          axiosConfig,
        ),
        axios.get(
          `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/company_features/get_features`,
          axiosConfig,
        ),
      ]);

      const companyPlansData = plansResponse?.data?.companyPlans ?? [];
      const companyFeaturesData = featuresResponse?.data?.companyFeatures ?? [];

      companyPlans = companyPlansData;
      companyFeatures = companyFeaturesData;

      if (process.env.NODE_ENV === "development") {
        console.group("Company Data");
        console.log("Plans:", companyPlansData);
        console.log("Features:", companyFeaturesData);
        console.groupEnd();
      }

      return {
        success: true,
        companyPlans: companyPlansData,
        companyFeatures: companyFeaturesData,
      };
    } catch (error) {
      if (
        axios.isCancel?.(error) ||
        error.name === "CanceledError" ||
        error.code === "ERR_CANCELED"
      ) {
        console.warn("Company data request was cancelled.");
        return;
      }

      console.error("Failed to fetch company data.", {
        code: error.code,
        status: error.response?.status,
      });

      return {
        success: false,
        message:
          error.response?.data?.message ||
          "Unable to load company data. Please try again.",
      };
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    apiGetCompanyData();
  }, []);
  return (
    <section className="fx-cl space6">
      {loading && <IsLoading />}
      <Header />

      <div className="pricing-container fx-cl fx-ac space5">
        <div className="fx-cl space2">
          <h1 className="title">Start Your Inventory Management Today</h1>
          <p className="subtitle">
            Transform how your business does inventory with our powerful system.
          </p>
        </div>
        <div className="fx-ac fx-jc">
          <div className="pricingBtnPln fx-ac fx-jc space3">
            <button
              className={billingCycle === "monthly" ? "active" : ""}
              onClick={() => setBillingCycle("monthly")}
            >
              Monthly
            </button>
            <button
              className={billingCycle === "yearly" ? "active" : ""}
              onClick={() => setBillingCycle("yearly")}
            >
              Annually <span className="pricingDiscount">-20%</span>
            </button>
          </div>
        </div>

        {/* PRICING CARDS */}

        <div className="pricing-grid">
          {companyPlans?.map((plan, index) => {
            const planFeatures =
              featuresArray.find((item) => item.slug === plan.slug)?.features ||
              [];
            return (
              <div
                key={plan._id}
                className={`pricing-card ${plan.slug} fx-cl fx-jb space2 ${
                  plan.recommended ? "highlight" : ""
                }`}
              >
                {plan.recommended && <div className="tag">Recommended</div>}

                <div className="fx-cl space2">
                  <h3>{plan.name}</h3>

                  <div className="fx-cl spacem">
                    <div className="price fx-ac fx-jc spacem">
                      <span className="actualPrice">
                        ₦
                        {billingCycle === "yearly"
                          ? Number(
                              plan.pricing.yearly.$numberDecimal,
                            ).toLocaleString()
                          : Number(
                              plan.pricing.monthly.$numberDecimal,
                            ).toLocaleString()}
                      </span>

                      <span className="pastPrice fx-cl">
                        <span style={{ textDecoration: "line-through" }}>
                          ₦
                          {billingCycle === "yearly"
                            ? (
                                Number(
                                  plan.pricing.actualPrice.$numberDecimal,
                                ) * 12
                              ).toLocaleString()
                            : Number(
                                plan.pricing.actualPrice.$numberDecimal,
                              ).toLocaleString()}
                        </span>

                        <span>{plan.currency}</span>
                      </span>
                    </div>

                    <div className="fx-ac fx-jc spacem">
                      <figure className="perOff">
                        {plan.pricing.discountPercent.$numberDecimal}% OFF
                      </figure>
                    </div>
                  </div>

                  <p className="users">
                    {billingCycle === "yearly"
                      ? `Billed annually`
                      : "Billed monthly"}
                  </p>

                  <button
                    className="planExecuteBtn"
                    onClick={() =>
                      redirect(
                        `/create_new_account?plan=${encodeURIComponent(
                          plan.slug,
                        )}&serviceId=${encodeURIComponent(plan.planId)}`,
                      )
                    }
                  >
                    Get Started
                  </button>
                </div>

                <div className="fx-cl space6 fg1 fx-jb">
                  <div className="fx-cl spacem">
                    <ul>
                      {planFeatures.map((feature, i) => (
                        <li key={i} className="fx-ac spacem">
                          <span className="planDiscHeading">
                            {feature.description}
                          </span>
                          <figure className="featuresIcon">
                            {feature.icon}
                          </figure>
                          <span className="featuresDisc">{feature.title}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <p className="prcFooter fx-cl space1">
                    <span>{plan.description}</span>

                    <p>
                      Supports up to {plan.limits.products.toLocaleString()}{" "}
                      products,
                      {` ${plan.limits.users}`} users and{" "}
                      {plan.limits.storageMB.toLocaleString()} MB storage.
                    </p>
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* COMPARISON TABLE */}
        <div
          className="fx-cl space6"
          style={{ padding: "0rem 2.4rem", width: "90%" }}
        >
          <div className="compare-title fx-cl spacem fx-jc">
            <h2 className="compare-title-btn">Compare Plans</h2>
            <p className="fs7">See how our plans compare side by side.</p>
          </div>
          <div className="fx-cl space3">
            <div className="tableHeaderPrices">
              <span style={{ fontstyle: "italic" }}>
                Manage your business inventory with smart tools designed for
                speed, accuracy, and growth — all in one powerful platform.
              </span>
              <div className="tableHeaderPricesCard fx-cl fx-ac space1">
                <span>
                  <strong>Standard</strong>
                </span>
                <span>₦4,850/mo</span>
                <button
                  className="planExecuteBtn"
                  onClick={() =>
                    redirect(
                      `/create_new_account?plan=${encodeURIComponent("standard")}&serviceId=${encodeURIComponent("347987sdafsdfa8afa")}`,
                    )
                  }
                >
                  Select Plan
                </button>
              </div>
              <div className="tableHeaderPricesCard fx-cl fx-ac space1">
                <span>
                  <strong>Professional</strong>
                </span>
                <span>₦7,500/mo</span>
                <button
                  className="planExecuteBtn"
                  onClick={() =>
                    redirect(
                      `/create_new_account?plan=${encodeURIComponent("professional")}&serviceId=${encodeURIComponent("347987sdafsdfa8afa")}`,
                    )
                  }
                >
                  Select Plan
                </button>
              </div>
              <div className="tableHeaderPricesCard fx-cl fx-ac space1">
                <span>
                  <strong>Premium</strong>
                </span>
                <span>₦16,500/mo</span>
                <button
                  className="planExecuteBtn"
                  onClick={() =>
                    redirect(
                      `/create_new_account?plan=${encodeURIComponent("premium")}&serviceId=${encodeURIComponent("347987sdafsdfa8afa")}`,
                    )
                  }
                >
                  Select Plan
                </button>
              </div>
              <div className="tableHeaderPricesCard fx-cl fx-ac space1">
                <span>
                  <strong>Enterprise</strong>
                </span>
                <span>₦31,850/mo</span>
                <button
                  className="planExecuteBtn"
                  onClick={() =>
                    redirect(
                      `/create_new_account?plan=${encodeURIComponent("enterprise")}&serviceId=${encodeURIComponent("347987sdafsdfa8afa")}`,
                    )
                  }
                >
                  Select Plan
                </button>
              </div>
            </div>

            <table className="compare-table">
              <thead>
                {/* <tr>
                <th>Feature</th>
                {plans.map((plan, index) => (
                  <th key={index}>{plan.name}</th>
                ))}
              </tr> */}
              </thead>

              <tbody>
                {comparisonSections.map((section, sectionIndex) => (
                  <React.Fragment key={sectionIndex}>
                    {/* Heading Row */}
                    <tr className="pricingHeadInTable">
                      <td colSpan={6}>{section.heading}</td>
                    </tr>

                    {/* Feature Rows */}
                    {section.rows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <span>{row.title}</span>

                            {row.badge && (
                              <span className="bg-blue-500 text-white text-xs px-2 py-1 rounded">
                                {row.badge}
                              </span>
                            )}
                          </div>
                        </td>

                        {row.values.map((val, i) => (
                          <td key={i} className="text-center px-4 py-3">
                            {val || <RemoveIcon />}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
}
